module.exports = __webpack_public_path__ + "static/media/3.b92d5c1e.png";